<template>  
    <div class="TableConfigDialog">
      <el-dialog  
          title="页面配置" 
          width="50%"
          :visible.sync="visible"
          :before-close="clearData"
          :show="show">
          <div class="content_box">
                <el-table :data="tableData" border style="width: 100%" height="300" :header-cell-style="{background:'#eef1f6',color:'#606266'}" :highlight-current-row="true">
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column prop="Name" align="center" label="名称"></el-table-column>
                    <el-table-column align="center" label="显示名">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.Rename" size="mini" class="input_sty"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="date" align="center" label="是否显示" width="80">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.Show" :disabled="scope.row.Must"></el-checkbox>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="center" label="是否打印" width="80">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.Print"></el-checkbox>
                        </template>
                    </el-table-column> -->
                </el-table>
          </div>
          <div class="content_footer_box">
            <el-button type="primary" size="mini" style="display:block" @click="restoreDefault">恢复默认</el-button>
            <el-button type="success" size="mini" style="display:block" @click="saveInfor">保存</el-button>
            <el-button size="mini" style="display:block" @click="$emit('update:show', false)">关闭</el-button>
          </div>
        </el-dialog>

    </div> 

</template>  

<script>

export default {
    // 注册组件
    components: {

    },
    data () {  
        return {
            visible: this.show,//是否显示弹出框
            initData:[],//保存初始数据
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        tableData:[Object,Array],
    },
    methods:{
        // 关闭前清除数据
        clearData(){
            this.$emit('update:show', false);
        },
        // 保存
        saveInfor(){
            // console.log(this.tableData)
            this.$emit('savePageConfig',this.tableData);
            this.$emit('update:show', false);
        },
        restoreDefault(){
            this.$emit('restoreDefault');
            this.$emit('update:show', false);
        },
    },
    watch: {  
        show (){  
            this.visible = this.show;
        },
    },
     // 创建生命周期钩子函数
    mounted() {

    }
};  
</script>

<style lang="less">
.TableConfigDialog{
  .el-dialog__header{
      background: rebeccapurple;
      // background: #4990d7;
      padding: 10px 10px 0;
      .el-dialog__title{
        color: #fff;
        font-size: 14px;
      }
      .el-dialog__headerbtn{
        top: 10px;
        right: 10px;
        .el-dialog__headerbtn .el-dialog__close{
          color: #fff;
        }
      }
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
.content_footer_box{
    display: -webkit-box !important;
    display: box !important;
    position:relative;
    -webkit-box-align:center;
    box-align:center;
    -webkit-box-pack:end;
    box-pack:end;
    margin: 10px auto 0;
}
}

</style>


// WEBPACK FOOTER //
// src/components/Dialog/HeadConfigDialog/HeadConfigDialog.vue